// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1c304e14] .ag-status-bar{padding-right:0 !important}[data-v-1c304e14] .lead-time{font-size:12px !important}@media(max-width: 991.98px){.filter-button[data-v-1c304e14]{height:38px}}.summary[data-v-1c304e14]{display:inline}.detail[data-v-1c304e14]{display:inline;padding-left:1px}", ""]);
// Exports
module.exports = exports;
